import './App.css';
import Logbook from './components/logbook/logbook';

function App() {
  return (
    <div className="App">
      <Logbook />
    </div>
  );
}

export default App;
